module.exports = __webpack_public_path__ + "school/img/shou.bf2e23e8.png";